export * from '../charts/ranking-bar/interface';
